<template>
<div class="xin">
    <!--
   <div class="toggle-btn" @click="toggleSidebar">
        折叠BreadCrumd
        -->
    <div class="app-main-container">

        <router-view></router-view>
    </div>
</div>
</template>

<script>
import {
    mapState,
    mapActions
} from "vuex";
import BreadCrumd from "./breadcrumb";
// import TopBar from "./topbar";
export default {
    inject: ['reload'],
    component: {
        BreadCrumd,
        // TopBar,
    },
    // components: {
    //     TopBar,
    // },
    computed: {
        ...mapState({
            isCollapse: (state) => state.common.isCollapse,
        }),
    },
    methods: {
        ...mapActions(["toggleSidebar"]),
    },
};
</script>

<style lang="less" scoped>
.xin {
    flex: 1;
    overflow: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    // height: 100%;
}

.toggle-btn {
    position: absolute;
    top: 50%;
    left: 2%;
    z-index: 1;
}

.app-main-container {
     margin: revert;
    flex: 1;
    // margin: 10px;
    overflow: auto;
    background: #F2F6FB;
    // height: calc(100% - 70px);
    // background: #f1f1f1;
    // padding-left: 10px;
    color: #333;
}
</style>
